// Not a typo these values map to the plc in a weird way
export default {
  alwaysRerun: 0,
  rerunRejects: 1,
  neverRerun: 3,
};
